import { render } from "./Cookiebanner.vue?vue&type=template&id=6a17ef65"
import script from "./Cookiebanner.vue?vue&type=script&lang=js"
export * from "./Cookiebanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__